
import rules from './checkRules'
import commonReq from './commonRequest'
import file from './file'
import thousandMark from './thousandMark'
export default {
  ...rules,
  ...commonReq,
  ...file,
  ...thousandMark,
}
